import { isPublicShellPath } from "./publicShellPaths";

const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

function pathnameOf(path) {
  return path.split(/[?#]/)[0];
}

export function isSafeReturnPath(path) {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) {
    return false;
  }
  return !isPublicShellPath(pathnameOf(path));
}

export function savePostLoginRedirect(path) {
  if (typeof sessionStorage === "undefined" || !isSafeReturnPath(path)) return;
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
}

export function consumePostLoginRedirect() {
  if (typeof sessionStorage === "undefined") return null;
  const path = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return isSafeReturnPath(path) ? path : null;
}

export function clearPostLoginRedirect() {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
}
